module.exports = __webpack_public_path__ + "assets/img/calm.40af2f12.svg";